// Display-only labels — the underlying values stay BOOLEAN/NUMERIC/STRING
// since that's what the backend stores and compares against.
export const FORMULA_TYPE_LABELS: { [key: string]: string } = {
  BOOLEAN: 'Trigger Formula',
  NUMERIC: 'Plan Amount',
  STRING: 'Why Description'
};

export function formulaTypeLabel(type: string): string {
  return FORMULA_TYPE_LABELS[type] || type;
}
